import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Box } from 'fw/components';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import Forms from './Forms';
import BasicInputs from './BasicInputs';
import Modals from './Modals';
import MultipleSelection from './MultipleSelection';
import DropDowns from './DropDowns';
import FileUploads from './FileUploads';
import DatePickers from './DatePickers';
import Coding from './Coding';
import Others from './Others';

import * as Help from 'modules/app/Help';

class PrimeroDemo extends React.Component {

	componentDidMount() {
		Help.setHelp(Help.demoHelpKey);
	}

	render() {
		return (
			<Router>
				<React.Fragment>
					<ContentHeader title="Primero Demo" description="Primero System's custom controls for our framework">
					</ContentHeader>
					<ContentBody>
						<Box title="Index">
							<Row>
								<Col md={2}>
									<ul>
										<li><Link to="/demo/primeroDemo/forms">Forms</Link></li>
										<li><Link to="/demo/primeroDemo/basic">Basic Inputs</Link></li>
										<li><Link to="/demo/primeroDemo/datePickers">Date Inputs</Link></li>
										<li><Link to="/demo/primeroDemo/dropDowns">Dropdowns</Link></li>
										<li><Link to="/demo/primeroDemo/multipleSelection">Multiple Selection</Link></li>
									</ul>
								</Col>
								<Col md={2}>
									<ul>
									<li><Link to="/demo/primeroDemo/modals">Modals</Link></li>
									<li><Link to="/demo/primeroDemo/fileUploads">Data Files</Link></li>
									<li><Link to="/demo/primeroDemo/others">Others</Link></li>
									<li><Link to="/demo/primeroDemo/coding">Coding</Link></li>
									</ul>
								</Col>
							</Row>
						</Box>
					</ContentBody>
					<Route exact path="/demo/primeroDemo/dropDowns" component={DropDowns} />
					<Route exact path="/demo/primeroDemo/datePickers" component={DatePickers} />
					<Route exact path="/demo/primeroDemo/modals" component={Modals} />
					<Route exact path="/demo/primeroDemo/fileUploads" component={FileUploads} />
					<Route exact path="/demo/primeroDemo/multipleSelection" component={MultipleSelection} />
					<Route exact path="/demo/primeroDemo/coding" component={Coding} />
					<Route exact path="/demo/primeroDemo/basic" component={BasicInputs} />
					<Route exact path="/demo/primeroDemo/forms" component={Forms} />
					<Route exact path="/demo/primeroDemo/others" component={Others} />
				</React.Fragment>
			</Router>
		);
	}
}
export default PrimeroDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/PrimeroDemo.js